import { Box, Typography } from "@mui/material";
import React from "react";
import StyledPaper from "./StyledPaper";
import { t } from "@lingui/macro";

const EditablePaper: React.FC<React.PropsWithChildren<{ title?: string, onEditClick: () => void}>> = (props) => {
    const { onEditClick, title, children} = props

    return <StyledPaper sx={{ display: 'flex', alignItems: 'center' }}>
        <Box flexGrow={1}>
            {title && <Typography variant='body1'>{title}</Typography>}
            {children}
        </Box>
        <Box onClick={onEditClick} pr={'8px'}>
            <Typography color={'secondary'}>{t`Edit`}</Typography>
        </Box>
    </StyledPaper>
}

export default EditablePaper;